// Кликнатият ред на „По артикули" → разбивката му по дни.
//
// Заявката носи ДВЕ неща наведнъж: стеснението на реда (`item_id`,
// `station_id`, `is_addon` — тройката, с която редът е уникален в таблицата)
// и АКТИВНИТЕ филтри на справката (период, категории, станции, видове). Без
// вторите сборът на дните би бил по-голям от самия ред под него.
//
// `search` няма аналог: drill-down-ът е по конкретен ред, не по текст, и BE-то
// не приема такъв параметър на `.../ordered-items/by-day`.

import { useCallback, useMemo, useState } from "react";

import { useOrderedItemsByDay } from "../../../../hooks/useReports";
import { parseDecimal } from "../../../../components/dataTable";
import type {
  OrderedItemsByDayFilters,
  OrderedItemsFilters,
} from "../../../../api/reports";
import type { NamedOrderedItem } from "./itemsColumns";

export const useItemDaysDrilldown = (reportFilters: OrderedItemsFilters) => {
  const [selectedItem, setSelectedItem] = useState<NamedOrderedItem | null>(
    null,
  );

  const dayFilters = useMemo<OrderedItemsByDayFilters>(() => {
    const next: OrderedItemsByDayFilters = {
      language_code: reportFilters.language_code,
      start_date: reportFilters.start_date,
      end_date: reportFilters.end_date,
      category_ids: reportFilters.category_ids,
      station_ids: reportFilters.station_ids,
      kinds: reportFilters.kinds,
    };
    if (selectedItem) {
      next.item_id = selectedItem.item_id;
      next.station_id = selectedItem.station_id;
      // `is_addon` се ПРЕСИЧА с `kinds`, не го заменя.
      next.is_addon = selectedItem.is_addon;
      next.is_lunch = selectedItem.is_lunch === true;
    }
    return next;
  }, [reportFilters, selectedItem]);

  // Хукът сам гаси заявката без период или без цел; `enabled` тук пази само
  // случая „модалът е затворен".
  const { data, isLoading, isError } = useOrderedItemsByDay(dayFilters, {
    enabled: selectedItem !== null,
  });

  const closeItem = useCallback(() => setSelectedItem(null), []);

  return {
    selectedItem,
    openItem: setSelectedItem,
    closeItem,
    days: data?.days ?? [],
    totalQuantity: parseDecimal(data?.total_count),
    grandTotal: parseDecimal(data?.grand_total),
    isLoading: selectedItem !== null && isLoading,
    isError,
  };
};
